module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/readable-stream/writable-browser.js
// module id = 1711
// module chunks = 1